/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var coll = document.getElementsByClassName("collaps");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}

const videoElements = document.querySelectorAll("video");
videoElements.forEach(video => {
  video.setAttribute("controlsList", "nodownload");
});

// Get all parent divs with class 'liquid.bg-white-liquid'
const liquidDivs = document.querySelectorAll('.liquid.bg-white-liquid');

// Loop through each parent div and check if its child div with class 'image-with-text' is empty,
// or if the parent div itself is empty
liquidDivs.forEach(div => {
  const imageWithTextDiv = div.querySelector('.image-with-text');
  if ((imageWithTextDiv && imageWithTextDiv.innerHTML.trim() === '') || div.innerHTML.trim() === '') {
    // If the child div is empty, or if the parent div is empty, add the 'display: none' style to the parent div
    div.style.display = 'none';
  }
});

var currentPageURL = window.location.href;
if (currentPageURL.includes("over-40-green-wall-to-choose-from")) {
  var galleryButton = document.querySelector('.gallery_button');
  galleryButton.setAttribute('target', '_blank');
}

function isMobileDevice() {
            return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
        }

        if (isMobileDevice()) {
            var newListItem = document.createElement('li');
            
            var newLinkItem = document.createElement('a');
            newLinkItem.href = 'tel:+1 786 723 3309'; 
            newLinkItem.className = 'footer__link-item link';
            newLinkItem.textContent = 'Call Us: +1 786 723 3309';

            newListItem.appendChild(newLinkItem);

            var list = document.querySelector('.footer__linklist');
            list.appendChild(newListItem);
        }